import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { GoodieGiveawayProductsComponent } from 'swag-client-common/components/partials/goodie-giveaway-products';
import { changeQuantity, toggleProduct } from 'swag-client-common/redux/goodie-giveaway/actions/goodie-giveaway-selection.actions';
import { getAllProducts } from 'swag-client-common/redux/goodie-giveaway/actions/goodie-giveaway-products.actions';
import { goodieGiveawayCategoriesListSelector } from 'swag-client-common/redux/goodie-giveaway/selectors/goodie-giveaway-categories.selectors';
import { goodieGiveawayProductsListSelector, goodieGiveawayProductsPageSelector, isLoadingGoodieGiveawayProductsSelector, shouldLoadMoreGoodieGiveawayProductsSelector } from 'swag-client-common/redux/goodie-giveaway/selectors/goodie-giveaway-products.selectors';
import { selectedGoodieProductsIdsSelector } from 'swag-client-common/redux/goodie-giveaway/selectors/goodie-giveaway-selection.selectors';
import { pathnameSelector } from '../../../redux/routing/routing.selectors';
import { giveawayLinkItemItemSelector, giveawayLinkRouteSelector, selectedGiveawayColorWithFallbackSelector } from '../../../redux/giveaway-landing/giveaway-landing.selectors';
const categoryIdSelector = createSelector(pathnameSelector, goodieGiveawayCategoriesListSelector, giveawayLinkItemItemSelector, (pathname, categories, item) => {
  const regex = `/goodie/${item === null || item === void 0 ? void 0 : item.link}/(.+)`;
  const match = pathname.match(new RegExp(regex));
  const categorySlug = match && match[1];
  if (categorySlug === '') {
    return undefined;
  }
  if (!categories) {
    return null;
  }
  const category = categories.find(category => category.slug === categorySlug);
  return category ? category._id : undefined;
});
const mapStateToProps = createStructuredSelector({
  categoryId: categoryIdSelector,
  products: goodieGiveawayProductsListSelector,
  page: goodieGiveawayProductsPageSelector,
  shouldLoadMore: shouldLoadMoreGoodieGiveawayProductsSelector,
  isLoading: isLoadingGoodieGiveawayProductsSelector,
  selectedProducts: selectedGoodieProductsIdsSelector,
  link: giveawayLinkRouteSelector,
  giveawayColor: selectedGiveawayColorWithFallbackSelector
});
const mapDispatchToProps = dispatch => ({
  onProductsLoad: params => {
    dispatch(getAllProducts(params));
  },
  onProductClick: (product, link) => {
    dispatch(toggleProduct(product, link));
  },
  onQuantityChange: (productId, quantity, link) => {
    dispatch(changeQuantity(productId, quantity, link));
  }
});
export const GiveawayLandingGoodieCatalog = connect(mapStateToProps, mapDispatchToProps)(GoodieGiveawayProductsComponent);